'use client';

import { HtmlRenderer } from '@eliadmin/core/src/components/ui/project-html-renderer';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { TourCardView, stripTourDescriptionBlocks, type TourCardProps } from './tour-card-view';

export function TourCard(props: TourCardProps) {
  const currency = useGlobalStore(state => state.generalLayout.currency);
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);
  return (
    <TourCardView
      {...props}
      currency={currency}
      locale={locale}
      labels={{
        past: t('text3975'),
        discount: t('text24').toLocaleLowerCase(),
        from: t('text811'),
        noDate: t('text3976'),
        more: t('text1861'),
      }}
      description={
        <HtmlRenderer
          html={stripTourDescriptionBlocks(props.tour?.short_description ?? '')}
          variant="description"
          className="max-h-10 overflow-hidden text-sm lg:max-h-14 lg:text-sm [&_p]:line-clamp-2 [&_p]:leading-5"
        />
      }
    />
  );
}
